import clsx from 'clsx';
import { CreditOutlook, EMPTY_CELL } from '../../CreditReportConstants';
import styles from './OutlookPill.module.scss';

interface OutlookPillProps {
    outlook: string | null | undefined;
}

function OutlookPill({ outlook }: OutlookPillProps) {
    const text = outlook?.trim();
    if (!text) return <>{EMPTY_CELL}</>;
    const word = text.toLowerCase();
    const variant = word === CreditOutlook.POSITIVE || word === CreditOutlook.NEGATIVE ? word : CreditOutlook.NEUTRAL;
    return <span className={clsx(styles.OutlookPill, styles[variant])}>{text}</span>;
}

export default OutlookPill;
